export default "__VITE_ASSET__CVPJTZ79__"